// views/Dashboard/Screenia/Screenia.tsx
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card/Card';
import Button from '../../../components/common/Button/Button';
import Loading from '../../../components/common/Loading/Loading';
import { ScreeniaSession } from '../../../Entities';
import { notify } from '../../../components/common/Toast/toastBridge';
import styles from './Screenia.module.css';

const Screenia = () => {
  const [copied, setCopied] = useState<number | string | null>(null);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [sessionIds, setSessionIds] = useState<string[]>([]);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ScreeniaSession.getAll();
      setSessionIds(response.session_ids);
      setLoading(false);
    } catch (error) {
      console.log(error);
      notify.error('Nepodařilo se načíst data');
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData]);

  const generateSessionId = async () => {
    try {
      setProcessing(true);
      const response = await ScreeniaSession.create();
      setSessionIds((prev) => [...prev, response.session_id]);
    } catch (error: any) {
      console.error(error);
      if (error?.message === 'max 3 session ids') {
        notify.warning('Maximálně můžete vytvořit 3 Screenia sessions najednou');
        return;
      }
      notify.error('Vytvoření nové Screenia session se nepovedlo');
    } finally {
      setProcessing(false);
    }
  };

  const handleCopy = (idx: number, sessionId: string) => {
    try {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(sessionId);
        setCopied(idx);
        setTimeout(() => setCopied(null), 2000);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = sessionId;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setCopied(idx);
      }
    } catch (error) {
      console.error('not copied');
      setCopied('Nelze zkopírovat');
    } finally {
      setTimeout(() => setCopied(null), 2000);
    }
  };

  if (loading) return <Loading />;

  return (
    <div className={styles.screeniasPage}>
      <h1>Screenia</h1>

      <Card className={styles.sessionCard}>
        <h2>Vaše Screenia sessions</h2>
        <p>Zkopírujte si Screenia sessionId a vložte do svého SCREENIA Chrome extension</p>

        {sessionIds.map((sessionId, idx) => (
          <div key={idx} className={styles.linkContainer}>
            <input
              type="text"
              value={sessionId}
              readOnly
              className={`form-input ${styles.linkInput}`}
              disabled
            />
            <Button onClick={() => handleCopy(idx, sessionId)}>
              {copied === idx ? 'Zkopírováno' : 'Zkopírovat'}
            </Button>
          </div>
        ))}
        <Button onClick={generateSessionId} disabled={processing} className={styles.generateSessionIdButton}>
          Generovat novou Screenia seanci
        </Button>
      </Card>
    </div>
  );
};

export default Screenia;
